import React, { useState } from 'react'
import EditDetailStyles from './AddCompanyDetail.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import axios from 'axios';
// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'

import { useLocation, useNavigate } from 'react-router-dom';
import useToast from '../../hooks/useToast';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';

const AddCompanyDetail = () => {
    const location = useLocation()

    // const data = location.state
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    // get data from redux
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);


    const inputRef = React.useRef();

    const [file, setFile] = useState(null)
    const [companyDetailsHeading, setCompanyDetailsHeading] = useState('');
    const [previewUrl, setPreviewUrl] = useState('');
    const [fileName, setFileName] = useState('');
    const [pdfSelect, setPdfSelect] = useState(false);


    const handleInputChange = (event) => {
      const { name, value } = event.target;
      setCompanyDetailsHeading(value);
    };
  

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFileName(selectedFile.name);
        setFile(selectedFile);
        setPreviewUrl(URL.createObjectURL(selectedFile));
        setPdfSelect(true);
      };
      const handleChoose = () => {
        inputRef.current.click();
      };
    
    const discardPdf = () => {
        setFile(null);
        setPreviewUrl('');
        setFileName('');
        setPdfSelect(false);
      };
    

    const handleSubmit = async (event) => {
        event.preventDefault()
        if (!file || !companyDetailsHeading) {
            // Validate if file and companyDetailsHeading are provided
            alert('Please provide a PDF and Title.');
            return;
          }

          const formDataObj = new FormData();
          formDataObj.append('file', file);
          formDataObj.append('companyDetailsHeading', companyDetailsHeading);
      
        try {
            openBackdrop(); 
            const pdfResponse = await axios.post(
                `${process.env.REACT_APP_COSMOSADMIN}/companydetails/uploadPdf`,
                formDataObj,
                {
                    headers: {
                        "Content-Type": "application/pdf"
                    }
                }
            )
            alert('Detail Added.')
            navigate('/companydetails')


            const companyResponse = await axios.post(
                `${process.env.REACT_APP_COSMOSADMIN}/companydetails/addCompanyDetails/${pdfResponse.data.pdfId}`,
                { companyDetailsHeading },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            closeBackdrop();


            const dateTime = companyResponse.data.date;
            const [dateString, timeString] = dateTime.split("T");
            const date = new Date(dateString);
            const time = timeString.substr(0, 8);


            const localDate = date.toLocaleDateString();

            dispatch(setNotifications({
                notification: {
                    name: name,
                    details: companyResponse.data.message,
                    time: time,
                    date: localDate
                }
            }))
            dispatch(setNotificationCount({
                count: count + 1,
            }))

            //   uptill here 
            alert('Detail Added.')
            discardPdf()
            navigate('/companydetails')

        } catch (error) {
            closeBackdrop();
            console.error(error)
        }
    }

    return (
        <>
            <Toast />
            <useBackdrop />

            <div className={EditDetailStyles.editDetailMain}>
                <div className={EditDetailStyles.editDetailContent}>
                    <form action="" className={EditDetailStyles.editDetailForm} onSubmit={handleSubmit} encType='multipart/form-data'>
                        <label className={EditDetailStyles.editDetailFormLabel}>Title</label>
                        <input className={EditDetailStyles.editDetailFormText}
                        type="text"
                        value={companyDetailsHeading}
                        name="companyDetailsHeading"
                        onChange={handleInputChange}
                      />
                        <label className={EditDetailStyles.editDetailFormLabel}>Upload</label>
                        <div className={EditDetailStyles.ImgInput}>
                            <input
                                ref={inputRef}
                                className={EditDetailStyles.ImgInput_input}
                                type="file"
                                onChange={handleFileChange}
                            />
                            {!previewUrl && <button type='button' onClick={handleChoose}>Browse</button>}
                            {previewUrl && (
                                <iframe src={previewUrl} width="100%" height="500px" title="PDF Preview" />
                            )}
                        </div>
                        <label className={EditDetailStyles.editDetailFormLabel}>Choose a PDF:</label>
                        <div className={EditDetailStyles.ImgInput_footer}>
                            {pdfSelect ?
                                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                    {fileName}
                                    <DeleteForeverOutlinedIcon onClick={discardPdf} sx={{ cursor: 'pointer' }} />
                                </div> :
                                ''}
                        </div>
                        <Button variant='contained' type='submit' className={EditDetailStyles.saveChanges}>Save changes</Button>
                    </form>
                </div>
            </div>
        </>
    )
}

export default AddCompanyDetail